import React, { useState } from 'react';

import { Button, Form, Modal } from 'react-bootstrap';

const HasChangeModal = (props: any) => {
  const [newValue, setNewValue] = useState(false);
   
  const conditionLink = ''; //Todo: give a proper link to a ressource

  const handleClose = () => {
    setNewValue(false);
    props.setShow(false);
  };

  const validate = () => {
    props.setData(newValue);
    props.setShow(false);
  };

  return (
    <Modal show={props.show} onHide={handleClose} className="m-0 p-0" centered>
      <Modal.Header closeButton>
        <div className="d-flex justify-content-start align-items-center text-center gap-2">
          <i className="bi bi-question-circle-fill" style={{ color: '#641ABF' }}></i>
          <p className="title-appointment m-0">Prendre rendez-vous plus tard ?</p>
        </div>
      </Modal.Header>
      <div className="mt-2 ms-2 text-apointment text-muted">
        <p className="ms-3 me-3">
          Vous n’êtes pas disponible le <strong>{props.date}</strong> pour votre état des lieux ? Dans ce cas, réservez
          un créneau la journée suivante.
        </p>
        <p className="ms-3 me-3 App-link fw-bold">Veuillez en informer votre agence par écrit.</p>
      </div>
      <div className="d-flex justify-content-center mt-3 mb-3 ms-3">
        <Form.Check
          type={'radio'}
          label={
            <p className="text-appointment m-0 fw-bold">
              Je confirme avoir pris connaissance des
              <u>
                <a href={conditionLink} rel="noreferrer" target="_BLANK" className="text-decoration-none text-black">
                  conditions
                </a>
              </u>
              .
            </p>
          }
          checked={newValue}
          onChange={() => setNewValue(!newValue)}
        />
      </div>
      <Modal.Footer className="m-0 p-0">
        <Button
          disabled={!newValue}
          onClick={() => validate()}
          variant="primary"
          className="w-100 m-0 rounded-0 rounded-bottom"
        >
          <p className="pt-3 pb-0">JE DÉCALE LE RENDEZ-VOUS</p>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HasChangeModal;
